import React, { useEffect, useState } from 'react'
import { StyledRange } from 'components/DatePickerStyles/DatePickerStyles'
import SeperatorIcon from 'components/icons/SeperatorIcon'
import CalendarIcon from 'components/icons/CalendarIcon'
import Label from 'components/Form/Label'
import {
  FormItem,
  Form,
} from 'modules/Students/Partials/StudentsInfoTable/Style/style'

const BatchFilter = ({
  cardNumber,
  setBatchFilter,
  submitFilter,
  filterData,
  batchValue,
  rangeValue,
  setRangeValue,
}) => {
  const [tapNumber, setTapNumber] = useState(null)
  const [rangeKey, setRangeKey] = useState(0)

  useEffect(() => {
    if (cardNumber !== tapNumber) {
      setTapNumber(cardNumber)
      setRangeValue([])
      setBatchFilter({ startBatch: '', endBatch: '' })
      setRangeKey(prevKey => prevKey + 1)
    }
    if (filterData !== false) {
      setRangeValue([])
      setBatchFilter({ startBatch: '', endBatch: '' })
      setRangeKey(prevKey => prevKey + 1)
    }
  }, [cardNumber, setBatchFilter, filterData])

  const onBatchChange = (value, years) => {
    setRangeValue(value)
    setBatchFilter({ startBatch: years[0], endBatch: years[1] })
  }
  return (
    <Form onFinish={submitFilter} id="Batch">
      <Label required={true}>Batch</Label>
      {/* <FormItem name="batch"> */}
      <StyledRange
        key={rangeKey}
        picker="year"
        placeholder={['YYYY', 'YYYY']}
        separator={<SeperatorIcon />}
        suffixIcon={<CalendarIcon />}
        value={rangeValue}
        onChange={onBatchChange}
      />
      {/* </FormItem> */}
    </Form>
  )
}

export default BatchFilter
